import type { DragLayerMonitor } from "react-dnd";
import { useDragLayer } from "react-dnd";
import type { GroupingField } from "../../../../../../../../api/types/svTypes.ts";
import { AreaItemType } from "../../../../../../../../api/types/svTypes.ts";
import GroupFieldItem from "../../tabular/table/GroupFieldItem";

const TableDragLayer: React.FC = () => {
  const { currentOffset, item, itemType } = useDragLayer((monitor: DragLayerMonitor) => {
    return {
      isDragging: monitor.isDragging(),
      currentOffset: monitor.getSourceClientOffset(),
      item: monitor.getItem<GroupingField>(),
      itemType: monitor.getItemType(),
    };
  });

  if (itemType === AreaItemType.GROUPS && currentOffset) {
    const field = item;

    return (
      <GroupFieldItem
        sx={{
          transform: `translate(${currentOffset.x}px, ${currentOffset.y}px)`,
          position: "fixed",
          top: 0,
          left: 0,
          pointerEvents: "none",
          width: "323px",
        }}
        field={field}
      />
    );
  }
  return null;
};

export default TableDragLayer;
